// Packages
import { createApp } from 'vue';

// Vue components
import FaqSearch from '@vue-components/FaqSearch.vue';

export default function init(): void {
  const containers = document.querySelectorAll<HTMLElement>('faq-search');

  if (containers.length === 0) {
    return;
  }

  containers.forEach((container) => {
    // Get props from the custom element's attributes
    const appId = container.getAttribute('app-id');
    const searchApiKey = container.getAttribute('search-api-key');
    const indexName = container.getAttribute('index-name');

    if (!appId || !searchApiKey || !indexName) {
      console.error('FaqSearch: Missing required attributes (app-id, search-api-key, index-name) on <faq-search> element.');
      return;
    }

    // Mount FaqSearch directly and pass props
    const vueInstance = createApp(FaqSearch, {
      appId: appId,
      searchApiKey: searchApiKey,
      indexName: indexName,
    });

    vueInstance.mount(container);
  });
}
